import { createTanstackQueryUtils } from "@-/com.npmjs.orpc__tanstack-query";

import { getOrpcClient } from "#orpc-client";

export const orpc = createTanstackQueryUtils(getOrpcClient);
